import React from 'react';
import ProfileLayout from '../../components/ProfileLayout';
import FAQContent from '../../components/FAQContent';

const FAQPage = () => {
  return (
    <ProfileLayout activeItem="faq">
      <FAQContent />
    </ProfileLayout>
  );
};

export default FAQPage;
